<mat-dialog-actions class=" dark-mode dark-bg px-3 m-0">
    <h3 class="text-white" style="font-size: 25px;">All Member</h3>
    <div class="col-12 col-sm-12 col-md-12 text-end pt-3">
        <mat-form-field class=" w-100" appearance="outline">
            <mat-icon class="text-white" matPrefix>search</mat-icon>
            <input type="text" placeholder="Search" matInput [(ngModel)]="pageQuery.search" (keyup)="searchUser($event)">
        </mat-form-field>
    </div>
</mat-dialog-actions>
<mat-dialog-content class=" dark-mode dark-bg">

    <div class="table-responsive-dark list-wrapper-bordered-dark" >
        <table class="table table-striped table-hover table-bordered ">
            <thead>
            <tr>
                <th class="text-nowrap">Full Name</th>
                <th class="text-nowrap">Email</th>
                <th class="text-nowrap">Date Joined</th>
                <th class="text-nowrap">Status</th>
                <th class="text-nowrap">Account Type</th>
                <th class="text-nowrap">User Role</th>
                <th style=" position: sticky; right: -13px; z-index: 2"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let user of users">
                <td class="text-nowrap" >{{ user.fullName }}</td>
                <td class="text-nowrap">{{ user.email }}
                </td>
                <td class="text-nowrap">{{ user.createDate| date : "MM/dd/y hh:mm:ss" }}</td>
                <td class="text-center" >
                    <mat-icon color="primary" *ngIf="user.enabled">verified_user</mat-icon>
                    <mat-icon color="warn" *ngIf="!user.enabled">no_accounts</mat-icon>
                </td>
                <td  class="ellipsis" >{{ user.accountType }}</td>
                <td class="text-nowrap" >{{user.role}}</td>
                <td style="white-space: nowrap; position: sticky; right: -13px; z-index: 2;">
                    <button (click)="chooseUser(user)" class="bg-accent-orange" mat-raised-button aria-label="edit user">
                        Choose
                    </button>
                </td>
            </tr>
            <tr *ngIf="users.length == 0">
                <td colspan="7" class="text-center">
                    <span>No Record</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</mat-dialog-content>
<mat-dialog-actions class=" dark-mode dark-bg p-0 m-0">
    <div class="mt-4 dark-bg px-4" style="width: 98%" *ngIf="users.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [dialogFlag]="true"
                [count]="totalRow"></app-pagination-dark>
    </div>
</mat-dialog-actions>
